
export const mountOnGoingDashboard = (result: any) => {
  return {
    ongoingRoute: result.startedRoute || 0,
    outOfRoute: result.outOfRoute || 0, 
    overdueRoute: result.overdueRote || 0,
    earlyRoute: result.earlyRoute || 0
  };
};